import { injectable } from 'inversify';

@injectable()
export class GenerateCodeUsecase {
  private readonly alphabet: string = '0123456789';
  private readonly codeLength: number = 6;

  async execute(): Promise<string> {
    let code = '';

    for (let i = 0; i < this.codeLength; i++) {
      const char: string = this.alphabet[Math.floor(Math.random() * (this.alphabet.length - 1))];
      code += char;
    }

    return code;
  }
}
